import type { PromptInputSubmission } from "@/components/ai/prompt-input/NewPromptInput";
import { Mode } from "@/components/ai/prompt-input/SpecModeToggle";

const LOCAL_STORAGE_PENDING_SUBMISSION = "onboarding-pending-submission";

const getPendingSubmissionKey = (organizationId: string) => `${LOCAL_STORAGE_PENDING_SUBMISSION}-${organizationId}`;

export const loadPendingSubmissionFromLocalStorage = (organizationId: string) => {
    const cachedSubmission = localStorage.getItem(getPendingSubmissionKey(organizationId));
    if (cachedSubmission) {
        const submission = JSON.parse(cachedSubmission, (_key, value) => {
            if (typeof value === "string" && /^\d+n$/.test(value)) {
                return BigInt(value.substring(0, value.length - 1));
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return value;
        }) as PromptInputSubmission;

        // Provide default mode for backward compatibility with old cached data
        if (!submission.mode) {
            submission.mode = Mode.Default;
        }

        return submission;
    }
    return null;
};

export const savePendingSubmissionToLocalStorage = (submission: PromptInputSubmission, organizationId: string) => {
    localStorage.setItem(
        getPendingSubmissionKey(organizationId),
        JSON.stringify(submission, (_key, value) => {
            if (typeof value === "bigint") {
                return value.toString() + "n";
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return value;
        }),
    );
};

export const clearPendingSubmissionFromLocalStorage = (organizationId: string) => {
    localStorage.removeItem(getPendingSubmissionKey(organizationId));
};

export const clearOnboardingStateFromLocalStorage = (): boolean => {
    const existed = localStorage.getItem("onboarding-state") !== null;
    localStorage.removeItem("onboarding-state");
    return existed;
};
